export enum RedirectUrlStatus {
	SUCCESS = 'success',
	ERROR = 'erreur'
}

export enum RedirectUrlTransactionMethod {
	CARD = 'recharge-cb',
	SSDD = 'recharge-ssdd',
	MONEY_OUT = 'retirez-votre-argent'
}
